<div class="modal-big">
    <h4>Algorithm Selection</h4>
    <div class="divider"></div>
    <div class="settings-block">
        <div class="block-text">
            <h6 class="subtitle-1">
                Select logic
            </h6>
            <p class="body-2">
                Pick the events that are most relevant to your analysis. The Events Selection option lets you define which data points the AI should prioritize, ensuring your insights are tailored to
                the specific actions and trends you care about.
            </p>
        </div>
        <div class="block-settings">
            <div class="table-container">
                <!-- Header row -->
                <div class="row header">
                    <div class="cell"></div>
                    <div class="cell cell-long">
                        <div class="subtitle-2">Variants</div>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row" [ngClass]="{'row-primary': selectedAlgorithm === DriverSelectionAlgorithm.Smart}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio" 
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.Smart"
                                   [(ngModel)]="selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">AI relevance prediction</span>
                        <span class="body-2">Automatically weighs impact, granularity and trend deviations</span>
                    </div>
                </div>
                <div class="row" [ngClass]="{'row-primary': selectedAlgorithm === DriverSelectionAlgorithm.AbsDesc}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio" 
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.AbsDesc"
                                   [(ngModel)]="selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">Largest absolute {{ outcomeName }} impact first</span>
                        <span class="body-2">E.g. -100, +100, +70, -70, +50, -50, ...</span>
                    </div>
                </div>
                <div class="row" [ngClass]="{'row-primary': selectedAlgorithm === DriverSelectionAlgorithm.SeqDesc}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio" 
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.SeqDesc"
                                   [(ngModel)]="selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">Largest positive {{ outcomeName }} impact first</span>
                        <span class="body-2">E.g. +100, +70, +10, -10, -70, ...</span>
                    </div>
                </div>
                <div class="row" [ngClass]="{'row-primary': selectedAlgorithm === DriverSelectionAlgorithm.SeqAsc}">
                    <div class="cell">
                        <label class="custom-radio is-dot">
                            <input type="radio" 
                                   name="selectedAlgorithm"
                                   [value]="DriverSelectionAlgorithm.SeqAsc"
                                   [(ngModel)]="selectedAlgorithm" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell cell-long">
                        <span class="subtitle-2">Largest negative {{ outcomeName }} impact first</span>
                        <span class="body-2">E.g. -100, -70, -10, +10, -+70, ...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="divider"></div>
    <div class="mt-16">
        <button (click)="save()" class="btn btn-primary mr-16">Apply</button>
        <button (click)="cancel()" class="btn btn-secondary">Cancel</button>
    </div>
    <a mat-dialog-close class="btn-close material-icons-outlined">close</a>
</div>
